import {ColorSource, Container, Graphics, Sprite, Text, TextStyle, Texture} from "pixi.js";
import {DRect} from "src/app/binst/primitives/drawable-rect";
import {PixiObject} from "../primitives/pixi-object";
import {BlueprintContext} from "../../../world/cyanprints/i-blueprint-context";
import {Rect, RectConstructor} from "../../../primitives/rect";
import * as PIXI from "pixi.js";


export function iconFontStyle(fill: ColorSource, fontSize: number, useSolid: boolean): TextStyle {
    const fontFamily = useSolid ? ["fa-solid"] : ["fa-regular"]
    const textStyle = new TextStyle({
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeight: "normal",
        fill: fill,
        wordWrap: false,
        breakWords: true,
        align: "left",
    });
    return textStyle;
}


export function textFontStyle(fill: ColorSource, fontSize: number, width: number): PIXI.TextStyle {
    const textStyle = new PIXI.TextStyle({
        fontFamily: ["inter"],
        fontSize: fontSize,
        fontWeight: "normal",
        fill: fill,
        wordWrap: true,
        wordWrapWidth: width,
        breakWords: true,
        align: "left",
    });
    return textStyle;
}

type IconDrawableConfig = {
    iconText: string;
    iconWidth: number;
    text: string;
    width: number;
    fontSize: number;
    colour: ColorSource;
    useSolidIcon: boolean;
    blueprintContext: BlueprintContext;
}

export class IconTextButtonDrawable extends PixiObject {
    blueprintContext: BlueprintContext;
    pixiText: Text;
    iconText: Text;
    override config: IconDrawableConfig

    constructor(config: IconDrawableConfig & {}) {
        if (typeof config.text !== "string") {
            console.log("Text needs to be a string: ", config.text);
            throw new Error("Text needs to be a string: " + config.text);
        }
        super({id: "icon-button-" + config.text.slice(0, 10)});
        this.blueprintContext = config.blueprintContext;
        this.config = config;
        this.build();
        this.touchPrimitive.showPointerCursor = true
    }

    updateText(text: string, useSolidIcon: boolean) {
        this.config.text = text;
        if (this.config.useSolidIcon !== useSolidIcon) {
            this.config.useSolidIcon = useSolidIcon;
            this.pixiText.text = text;
            this.build();
        }
        this.config.useSolidIcon = useSolidIcon;
        this.pixiText.text = text;
        this.requestRender()
    }

    private build() {
        if (this.pixiText) {
            this.sprite.removeChild(this.pixiText);
            this.pixiText.destroy();
        }
        if (this.iconText) {
            this.sprite.removeChild(this.iconText);
            this.iconText.destroy();
        }
        this.pixiText = new Text({
            text: this.config.text,
            // resolution: 2,
            style: textFontStyle(this.config.colour, this.config.fontSize, this.config.width)
        });
        this.iconText = new Text({
            text: this.config.iconText,
            // resolution: 2,
            style: iconFontStyle(this.config.colour, this.config.iconWidth, this.config.useSolidIcon)
        });
        this.pixiText.text = this.config.text
        this.iconText.text = this.config.iconText
        this.pixiText.x = this.iconText.width + 5;
        this.pixiText.y = 4;
        this.sprite.addChild(this.pixiText);
        this.sprite.addChild(this.iconText);
    }

    override setupDefaultInteractions() {
        // Click on image to view full size
        this.touchPrimitive.onPressed( (pt) => {
            console.log('Icon button clicked:', this.id);
            // Dispatch action to open image viewer
            return false; // Stop propagation
        });
        this.touchPrimitive.onPressed( (pt) => {
            // this.pixiText.alpha = 0.5;
            this.requestRender()
            return true; // Stop propagation
        });
        this.touchPrimitive.onReleased( (pt) => {
            // this.pixiText.alpha = 1;
            this.requestRender()
            return true; // Stop propagation
        });
    }

    addDebugRect(width, height) {
        const graphics = new Graphics({});
        const rect = new DRect({
            left: 0,
            top: 0,
            right: width,
            bottom: height,
            roundness: 5,
            colour: "rgba(58,52,49,0.53)",
        });
        rect.render(graphics);
        this.sprite.addChild(graphics);
    }
}

